import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const UserBubble = styled.div`
  align-self: flex-end;
  max-width: 70%;
  background: ${colors.purple300};
  color: ${colors.white100};
  padding: 10px 14px;
  border-radius: 16px 16px 4px 16px;
  font-size: 16px;
  line-height: 1.5;
  word-break: break-word;

  span {
    white-space: pre-wrap;
  }
`
